export class AdminHomePageModel {
  public medicinesCount: number;
  public activeIngredientsCount: number;
  public inactiveIngredientsCount: number;
  public atcCodesCount: number;
  public manufacturersCount: number;
  public foodAndAlcoholCount: number;
  public diseasesCount: number;
  public anatomicalSystemsCount: number;
}